import Vue from 'vue'
import App from './Download.vue'
import {AboutRouter} from './router'
import {installGoogleAnalytics} from "@/components/Analytics";

Vue.config.productionTip = false

installGoogleAnalytics();

new Vue({
  router: AboutRouter,
  render: h => h(App)
}).$mount('#app')
